module.exports = __webpack_public_path__ + "img/cleanup1-7-8-2021.997a3969.jpg";